import { Flex, Text } from '@chakra-ui/react'
import React from 'react'
import { ExtensionBadge } from '~/components/shared/ExtensionBadge'
import { formatPhoneNumber } from '~/utils/formatter'

import { toNounCasing } from '@mangovoice/core'
import { Contact, ContactPhoneNumber } from '@mangovoice/types'

interface ContactSearchListItemProps {
  contact: Contact
  contactPhoneNumber: ContactPhoneNumber
  isExtension: boolean
  noNumberLabel?: string
}
export const ContactSearchListItem = ({
  contact,
  contactPhoneNumber,
  isExtension,
  noNumberLabel,
}: ContactSearchListItemProps) => {
  const hasNumber = Boolean(contactPhoneNumber.number)
  return (
    <Flex
      flexDirection="row"
      width="100%"
      height="auto"
      bg="transparent"
      p="0.75rem"
      cursor={hasNumber ? 'pointer' : 'not-allowed'}
      opacity={hasNumber ? 1 : 0.5}
      userSelect="none"
    >
      <Flex flex="1" flexShrink="0" gap="2.5rem" alignItems="center">
        <Text as={'span'} lineClamp={1}>
          {toNounCasing(`${contact.given_name} ${contact.family_name}`)}
        </Text>
      </Flex>
      <Flex flex="1" flexShrink="0" gap="2.5rem" alignItems="center">
        <Text
          as={'span'}
          lineClamp={1}
          color={!hasNumber ? 'fg.muted' : undefined}
        >
          {!hasNumber && noNumberLabel}
          {hasNumber &&
            !isExtension &&
            `${toNounCasing(contactPhoneNumber.label ?? '')}: `}
          {hasNumber && !isExtension
            ? formatPhoneNumber(contactPhoneNumber.number)
            : ''}
          {hasNumber && isExtension && (
            <ExtensionBadge extension={contactPhoneNumber.number} />
          )}
        </Text>
      </Flex>
    </Flex>
  )
}
